let TENANT = window.TENANT;
if (!TENANT) {
  TENANT = window.EVENTIVE_CONFIG;
}

export default {
  owner: TENANT.owner,
  event_bucket: TENANT.event_bucket,
  api_key: TENANT.api_key,
  fee: TENANT.fee,
  endpoint: TENANT.endpoint,
  root_domain: process.env.ROOT_DOMAIN,
  facebook_app_id: process.env.FACEBOOK_APP_ID,
  keen_project_id: process.env.KEEN_PROJECT_ID,
  keen_write_key: process.env.KEEN_WRITE_KEY,
  login_url: `${window.location.protocol}//login.${process.env.ROOT_DOMAIN}`
};



// WEBPACK FOOTER //
// ./src/app/config.js